import type { CalendarTab } from "./constants";
import type { EventFilterValues } from "./pages/calendar-overview/components/EventFilterDrawer";

export const calendarRoutes = {
  list: "",
  reservationDetails: "assets/:aid/reservations/:rid",
} as const;

export type CalendarRouteParams = {
  list: {
    tab?: CalendarTab;
    search?: string;
  } & Partial<Record<keyof EventFilterValues, string>>;
};
